import {
  erpPageBreadcrumbClass,
  erpPageBreadcrumbCurrentClass,
  erpPageBreadcrumbItemClass,
  erpPageBreadcrumbSepClass,
} from '@euroasiann/shared/ui';

export function TermsOfUsePage() {
  return (
    <div className="w-full space-y-6">
      <div>
        <nav className={`${erpPageBreadcrumbClass} mb-2`} aria-label="Breadcrumb">
          <span className={erpPageBreadcrumbItemClass}>Legal</span>
          <span className={erpPageBreadcrumbSepClass}>/</span>
          <span className={erpPageBreadcrumbCurrentClass}>Terms of Use</span>
        </nav>
        <h1 className="text-3xl font-bold text-[hsl(var(--foreground))]">Terms of Use</h1>
      </div>
      <div className="bg-[hsl(var(--card))] rounded-xl p-8 border border-[hsl(var(--border))] space-y-4 text-[hsl(var(--foreground))]">
        <p className="text-[hsl(var(--muted-foreground))] leading-relaxed">
          By accessing and using the Euroasiann Admin Portal, you agree to comply with these terms
          and all applicable platform governance and data-protection policies.
        </p>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold">1. Platform Access</h2>
          <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
            Access is granted to authorized Euroasiann administrators. You are responsible for
            safeguarding login credentials and reporting unauthorized use immediately.
          </p>
        </section>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold">2. Acceptable Use</h2>
          <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
            The admin portal may be used for organization management, licensing, support operations,
            and platform configuration. Misuse or attempts to bypass security controls are prohibited.
          </p>
        </section>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold">3. Data & Confidentiality</h2>
          <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
            Customer, vendor, and operational data accessed through this portal must be handled in
            accordance with Euroasiann policies and applicable regulations.
          </p>
        </section>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold">4. Support</h2>
          <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
            For questions about these terms, contact your platform administrator or raise a support
            ticket from the Support section.
          </p>
        </section>
      </div>
    </div>
  );
}
